// Tiny module-scoped store for the most-recently-loaded script id.
// file.js writes; pdf.js + history-trim helpers read. Lets us avoid
// threading the id through every bridge method just so PDF export
// can know which script to render.

let _current = null;

export function setActiveScriptId(id) {
  _current = id || null;
}

export function getActiveScriptId() {
  return _current;
}
